module.exports = __webpack_public_path__ + "img/rspca-tas.abc885c.png";